// Styles librairies
import 'owl.carousel/dist/assets/owl.carousel.min.css'

// Scripts librairies
import 'owl.carousel'

// Docs https://codepen.io/ekabir/pen/ypNOZe?editors=1010

// On cherche les 2 carousel que l'on veut synchroniser
const sync1 = $('#sync1.owl-carousel')
const sync2 = $('#sync2.owl-carousel')

const slidesPerPage = 1 // définir globalement le nombre d'éléments par page
const syncedSecondary = true // Permettre au deuxieme slider de gerer le premier (true/false)

// Definit le premier slider
const slider = sync1.owlCarousel({
  items: 1,
  autoplayTimeout: 7000,
  nav: false,
  autoplay: true,
  dots: true,
  loop: false,
  rewind: true,
  lazyload: true,
  autoplayHoverPause: true,
  animateIn: 'fadeIn',
  animateOut: 'fadeOut'
}).on('changed.owl.carousel', syncPosition) // Au changement du carousel on appel syncPosition
slider.on('change.owl.carousel', function (e) {
  // console.log(e)
  const current = e.item.index
  // console.log('Next slide is ' + (current+1));
  $(e.target).find('.owl-item').eq(current + 1).find('.slide').addClass('d-block')
})

// On initialise le deuxieme carousel
const slider2 = sync2
  .on('initialized.owl.carousel', function () {
    sync2.find('.owl-item').eq(0).addClass('current')
  })
  .owlCarousel({
    items: slidesPerPage,
    autoplayTimeout: 7000,
    nav: false,
    dots: false,
    loop: false,
    rewind: true,
    autoplayHoverPause: true,
    slideBy: slidesPerPage, // vous pouvez également faire glisser par 1, de cette façon, la diapositive active collera au premier élément du deuxième carrousel
    animateIn: 'fadeIn',
    animateOut: 'fadeOut'
  }).on('changed.owl.carousel', syncPosition2) // Au changement du carousel on appel syncPosition2
slider2.on('change.owl.carousel', function (e) {
  // console.log(e)
  const current = e.item.index
  // console.log('Next slide is ' + (current+1));
  $(e.target).find('.owl-item').eq(current + 1).find('.text').addClass('d-block')
})

function syncPosition (el) {
  // si vous définissez loop sur false, vous devez restaurer cette ligne suivante
  const current = el.item.index

  /*
  // si vous désactivez la boucle, vous devez commenter ce bloc
  var count = el.item.count - 1
  var current = Math.round(el.item.index - (el.item.count / 2) - 0.5)
  if (current < 0) {
    current = count
  }
  if (current > count) {
    current = 0
  }
  // fin du block
  */

  sync2
    .find('.owl-item')
    .removeClass('current')
    .eq(current)
    .addClass('current')
  const onscreen = sync2.find('.owl-item.active').length - 1
  const start = sync2.find('.owl-item.active').first().index()
  const end = sync2.find('.owl-item.active').last().index()

  if (current > end) {
    sync2.data('owl.carousel').to(current, 100, true)
  }
  if (current < start) {
    sync2.data('owl.carousel').to(current - onscreen, 100, true)
  }
}

function syncPosition2 (el) {
  if (syncedSecondary) {
    const number = el.item.index
    sync1.data('owl.carousel').to(number, 100, true)
  }
}

sync2.on('click', '.owl-item', function (e) {
  e.preventDefault()
  const number = $(this).index()
  sync1.data('owl.carousel').to(number, 300, true)
})

// hax pour les boutons dans les sliders
sync2.find('a.btn').on('click', function (e) {
  e.stopPropagation()
  $(this).get(0).click()
})
